import type { CSSProperties } from 'react';

/** Panel önizlemesi — vitrin getLogoImageStyle ile aynı davranış */
export function getLogoImageStyle(options: {
  width?: number | null;
  height?: number | null;
  scale?: number;
  objectPosition?: string;
}): CSSProperties {
  const scale = Number.isFinite(options.scale) && (options.scale as number) > 0 ? (options.scale as number) : 1;
  const rawWidth = Number(options.width);
  const rawHeight = Number(options.height);
  const width = Number.isFinite(rawWidth) && rawWidth > 0 ? Math.round(rawWidth * scale) : undefined;
  const height = Number.isFinite(rawHeight) && rawHeight > 0 ? Math.round(rawHeight * scale) : undefined;

  return {
    width: width ? `${width}px` : 'auto',
    minWidth: width ? `${width}px` : undefined,
    // Tailwind/MUI img max-width:100% genişliği ezer — açıkça kapat
    maxWidth: 'none',
    height: height ? `${height}px` : 'auto',
    flexShrink: 0,
    objectFit: 'contain',
    objectPosition: options.objectPosition || 'center center',
    display: 'block',
  };
}
